import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 340px',
        gap: '20px',
        width: '100%',

        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr'
        }
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '40px',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '10px',

        '& > h1': {
            fontSize: '28px',
        }
    },
    bold: {
        fontWeight: 'bold'
    },
    highlight: {
        color: '#009EFF',
    },
    link: {
        color: '#009EFF',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        }
    }
}))

const getRestrictedProductsData = (lang) => {
    const classes = useStyles()

    const trans = (contentTh, contentEn) => {
        if (lang === 'en') return contentEn
        return contentTh
    }

    const renderLogo = (src, alt = '') => {
        return (
            <img alt={alt} src={src} style={{ objectFit: 'contain', objectPosition: 'center', width: '120px', height: '120px' }} />
        )
    }

    return {
        TheFineArts: {
            title: trans('กรมศิลปากร', 'กรมศิลปากร'),
            logo: renderLogo('/static/img/faq/the-fine-arts.png', 'the fine arts department'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมศิลปากร</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ศิลปวัตถุ/พระพุทธรูป/เครื่องราง</h1>
                            </div>

                            <p>
                                <span className={classes.bold}>ต้องขออนุญาตส่งออก</span> โบราณวัตถุหรือศิลปวัตถุ ประเภทพระพุทธรูป และรูปเคารพ (เทวรูป ในศาสนาพราหมณ์ฮินดู เช่น พระพิฆเนศ พระแม่ลักษมี พระแม่อุมาเทวี พระแม่กาลี พระศิวะ พระนารายณ์ พระกฤษณะ พระแม่รารา) และจี้พระห้อยคอ/พระเหรียญ ต้องมีอายุเกิน 5 ปี
                                <span className={classes.bold}> นับจากวันที่หล่อ หรือผลิต โดยวัน/เดือน/ปี ที่หล่อหรือผลิตจะต้องระบุอยู่บนองค์ พระพุทธรูป รูปเคารพ และจี้พระห้อยคอ/พระเหรียญ</span>
                            </p>

                            <p>หากไม่มีปีที่ผลิตระบุบนโบราณวัตถุ/ศิลปวัตถุ จะต้องดำเนินการขออนุญาตส่งออกทุกกรณี</p>

                            <p className={classes.bold}>หากศิลปวัตถุ (พระพุทธรูปหน้าตัก รูปเคารพ และจี้พระ/พระเหรียญ) อายุไม่เกิน 5 ปี และ ไม่ได้ขึ้นทะเบียนการนำโบราณวัตถุหรือศิลปวัตถุผ่านราชอาณาจักร สามารถส่งออกได้โดย ไม่ต้องขออนุญาต</p>

                            <p className={classes.bold}>จี้เครื่องราง สามารถส่งออกได้โดยไม่ต้องขออนุญาต</p>

                            <p>เทวรูปอื่นที่มีบทบาทในพระพุทธศาสนา เช่น ท้าวจตุโลกบาล ท้าวเวสสุวรรณ พญานาค ท้าวจตุคามรามเทพ รูปหล่อรัชกาลที่ 5 ไอ้ไข่เด็กวัดเจดีย์ ฯลฯ สามารถส่งข้อมูลให้นักวิชาการ ทําการประเมินเบื้องต้น โดยสอบถามสำนักพิพิธภัณฑสถานแห่งชาติทางอีเมลได้ที่ ask.nswmuseum@hotmail.com พร้อมรายละเอียดดังนี้</p>

                            <div style={{ marginLeft: '20px' }}>
                                <p>1. ภาพถ่ายที่ชัดเจน (ไฟล์JPG)</p>
                                <p>2. วัสดุที่ใช้ผลิต</p>
                                <p>3. ขนาดของวัตถุ</p>
                                <p>4. ชื่อและเบอร์โทรติดต่อ</p>
                            </div>

                            <p className={classes.bold}>ติดต่อสอบถามเพิ่มเติม</p>
                            <p>งานควบคุมโบราณวัตถุ ศิลปวัตถุ สำนักพิพิธภัณฑสถานแห่งชาติ นางนิษฐา สามกองงาม, นายปาฏิหาริย์ เร่งเจริญ</p>
                            <p>กรมศิลปากร กระทรวงวัฒนรรรม</p>
                            <p>โทร.02164 2501 ต่อ 1011</p>

                            <a href="http://nsw.finearts.go.th" target='_blank' className={classes.link}>nsw.finearts.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt="the fine arts department" src='/static/img/faq/the-fine-arts-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมศิลปากร</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ศิลปวัตถุ/พระพุทธรูป/เครื่องราง</h1>
                            </div>

                            <p>
                                <span className={classes.bold}>ต้องขออนุญาตส่งออก</span> โบราณวัตถุหรือศิลปวัตถุ ประเภทพระพุทธรูป และรูปเคารพ (เทวรูป ในศาสนาพราหมณ์ฮินดู เช่น พระพิฆเนศ พระแม่ลักษมี พระแม่อุมาเทวี พระแม่กาลี พระศิวะ พระนารายณ์ พระกฤษณะ พระแม่รารา) และจี้พระห้อยคอ/พระเหรียญ ต้องมีอายุเกิน 5 ปี
                                <span className={classes.bold}> นับจากวันที่หล่อ หรือผลิต โดยวัน/เดือน/ปี ที่หล่อหรือผลิตจะต้องระบุอยู่บนองค์ พระพุทธรูป รูปเคารพ และจี้พระห้อยคอ/พระเหรียญ</span>
                            </p>

                            <p>หากไม่มีปีที่ผลิตระบุบนโบราณวัตถุ/ศิลปวัตถุ จะต้องดำเนินการขออนุญาตส่งออกทุกกรณี</p>

                            <p className={classes.bold}>หากศิลปวัตถุ (พระพุทธรูปหน้าตัก รูปเคารพ และจี้พระ/พระเหรียญ) อายุไม่เกิน 5 ปี และ ไม่ได้ขึ้นทะเบียนการนำโบราณวัตถุหรือศิลปวัตถุผ่านราชอาณาจักร สามารถส่งออกได้โดย ไม่ต้องขออนุญาต</p>

                            <p className={classes.bold}>จี้เครื่องราง สามารถส่งออกได้โดยไม่ต้องขออนุญาต</p>

                            <p>เทวรูปอื่นที่มีบทบาทในพระพุทธศาสนา เช่น ท้าวจตุโลกบาล ท้าวเวสสุวรรณ พญานาค ท้าวจตุคามรามเทพ รูปหล่อรัชกาลที่ 5 ไอ้ไข่เด็กวัดเจดีย์ ฯลฯ สามารถส่งข้อมูลให้นักวิชาการ ทําการประเมินเบื้องต้น โดยสอบถามสำนักพิพิธภัณฑสถานแห่งชาติทางอีเมลได้ที่ ask.nswmuseum@hotmail.com พร้อมรายละเอียดดังนี้</p>

                            <div style={{ marginLeft: '20px' }}>
                                <p>1. ภาพถ่ายที่ชัดเจน (ไฟล์JPG)</p>
                                <p>2. วัสดุที่ใช้ผลิต</p>
                                <p>3. ขนาดของวัตถุ</p>
                                <p>4. ชื่อและเบอร์โทรติดต่อ</p>
                            </div>

                            <p className={classes.bold}>ติดต่อสอบถามเพิ่มเติม</p>
                            <p>งานควบคุมโบราณวัตถุ ศิลปวัตถุ สำนักพิพิธภัณฑสถานแห่งชาติ นางนิษฐา สามกองงาม, นายปาฏิหาริย์ เร่งเจริญ</p>
                            <p>กรมศิลปากร กระทรวงวัฒนรรรม</p>
                            <p>โทร.02164 2501 ต่อ 1011</p>

                            <a href="http://nsw.finearts.go.th" target='_blank' className={classes.link}>nsw.finearts.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt="the fine arts department" src='/static/img/faq/the-fine-arts-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>
            )
        },
        TheAgriculture: {
            title: 'กรมวิชาการเกษตร',
            logo: renderLogo('/static/img/faq/the-agriculture.png', 'the agriculture department'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมวิชาการเกษตร</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ต้นไม้/ส่วนประกอบของพืช</h1>
                            </div>

                            <p>ไม่เป็นพืชอนุรักษ์ที่อยู่ในบัญชีรายชื่อพืชอนุรักษ์ (CITES) ตามประกาศของกระทรวงเกษตร และสหกรณ์</p>

                            <p>มีใบรับรองสุขอนามัยพืช และการขึ้นทะเบียนรับรองจากสำนักควบคุมพืชและวัสดุการเกษตร</p>

                            <a href="https://www.doa.go.th" target='_blank' className={classes.link}>www.doa.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the agriculture department' src='/static/img/faq/the-agriculture-details.png' style={{ objectFit: 'cover', objectPosition: 'center'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมวิชาการเกษตร</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ต้นไม้/ส่วนประกอบของพืช</h1>
                            </div>

                            <p>ไม่เป็นพืชอนุรักษ์ที่อยู่ในบัญชีรายชื่อพืชอนุรักษ์ (CITES) ตามประกาศของกระทรวงเกษตร และสหกรณ์</p>

                            <p>มีใบรับรองสุขอนามัยพืช และการขึ้นทะเบียนรับรองจากสำนักควบคุมพืชและวัสดุการเกษตร</p>

                            <a href="https://www.doa.go.th" target='_blank' className={classes.link}>www.doa.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='The agriculture details' src='/static/img/faq/the-agriculture-details.png' style={{ objectFit: 'cover', objectPosition: 'center'}} />
                        </div>
                    </div>
                </>
            )
        },
        TheFoodAndDrug: {
            title: 'สำนักงานกรรมการอาหารและยา',
            logo: renderLogo('/static/img/faq/the-food-and-drug.png', 'the food and drug administration'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>สำนักงานกรรมการอาหารและยา</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>อาหารและยา</h1>
                            </div>

                            <p className={classes.bold}>อาหาร และเครื่องดื่ม</p>
                            <p>มีเลขสารบบอาหารบนเครื่องหมาย อย.</p>

                            <p className={classes.bold}>ยารักษาโรค/ยาประจําตัว</p>
                            <p style={{ margin: 0 }}>มีเลขทะเบียนตำรับยาบนฉลากผลิตภัณฑ์</p>
                            <p style={{ margin: 0 }}>มีใบรับรองแพทย์ออกให้เป็นภาษาอังกฤษ ระบุชื่อผู้รับปลายทาง และชื่อยา</p>

                            <p className={classes.bold}>อาหารเสริม/เครื่องสำอาง</p>
                            <p style={{ margin: 0 }}>มีเลขที่ใบรับจดแจ้งบนฉลากผลิตภัณฑ์</p>
                            <p style={{ margin: 0 }}>บรรจุภัณฑ์ได้มาตรฐาน ไม่รั่วไหล/ซึม</p>

                            <a href="https://www.fda.moph.go.th" target='_blank' className={classes.link}>www.fda.moph.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the food and drug administration' src='/static/img/faq/the-food-and-drug-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>สำนักงานกรรมการอาหารและยา</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>อาหารและยา</h1>
                            </div>

                            <p className={classes.bold}>อาหาร และเครื่องดื่ม</p>
                            <p>มีเลขสารบบอาหารบนเครื่องหมาย อย.</p>

                            <p className={classes.bold}>ยารักษาโรค/ยาประจําตัว</p>
                            <p style={{ margin: 0 }}>มีเลขทะเบียนตำรับยาบนฉลากผลิตภัณฑ์</p>
                            <p style={{ margin: 0 }}>มีใบรับรองแพทย์ออกให้เป็นภาษาอังกฤษ ระบุชื่อผู้รับปลายทาง และชื่อยา</p>

                            <p className={classes.bold}>อาหารเสริม/เครื่องสำอาง</p>
                            <p style={{ margin: 0 }}>มีเลขที่ใบรับจดแจ้งบนฉลากผลิตภัณฑ์</p>
                            <p style={{ margin: 0 }}>บรรจุภัณฑ์ได้มาตรฐาน ไม่รั่วไหล/ซึม</p>

                            <a href="https://www.fda.moph.go.th" target='_blank' className={classes.link}>www.fda.moph.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the food and drug administration' src='/static/img/faq/the-food-and-drug-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        },
        MIND: {
            title: 'กระทรวงอุตสาหกรรม',
            logo: renderLogo('/static/img/faq/mind.png', 'the ministry of industry'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กระทรวงอุตสาหกรรม</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ชิ้นส่วนยานพาหนะ</h1>
                            </div>

                            <a href="https://www.industry.go.th" target='_blank' className={classes.link}>www.industry.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the ministry of industry' src='/static/img/faq/mind-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กระทรวงอุตสาหกรรม</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ชิ้นส่วนยานพาหนะ</h1>
                            </div>

                            <a href="https://www.industry.go.th" target='_blank' className={classes.link}>www.industry.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the ministry of industry' src='/static/img/faq/mind-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        },
        TheExciseDepartment: {
            title: 'กรมสรรพสามิต',
            logo: renderLogo('/static/img/faq/the-excise-department.png', 'the excise department'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมสรรพสามิต</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>บุหรี่ ยาสูบ เครื่องดื่มแอลกอฮอล์</h1>
                            </div>

                            <a href="https://www.excise.go.th" target='_blank' className={classes.link}>www.excise.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the excise department' src='/static/img/faq/the-excise-department-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมสรรพสามิต</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>บุหรี่ ยาสูบ เครื่องดื่มแอลกอฮอล์</h1>
                            </div>

                            <a href="https://www.excise.go.th" target='_blank' className={classes.link}>www.excise.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the excise department' src='/static/img/faq/the-excise-department-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        },
        DOPA: {
            title: 'กรมการปกครอง',
            logo: renderLogo('/static/img/faq/dopa.png', 'dopa'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมการปกครอง</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>อาวุธ กระสุนปืน วัถตุระเบิด</h1>
                            </div>

                            <a href="https://www.dopa.go.th" target='_blank' className={classes.link}>www.dopa.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the ministry of industry' src='/static/img/faq/dopa-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมการปกครอง</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>อาวุธ กระสุนปืน วัถตุระเบิด</h1>
                            </div>

                            <a href="https://www.dopa.go.th" target='_blank' className={classes.link}>www.dopa.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='the ministry of industry' src='/static/img/faq/dopa-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        },
        DLD: {
            title: 'กรมปศุสัตว์',
            logo: renderLogo('/static/img/faq/dld.png', 'department of livestock development'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมปศุสัตว์</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>สัตว์มีชีวิต และซากสัตว์</h1>
                            </div>

                            <a href="https://www.dld.go.th" target='_blank' className={classes.link}>www.dld.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='department of livestock development' src='/static/img/faq/dld-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมปศุสัตว์</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>สัตว์มีชีวิต และซากสัตว์</h1>
                            </div>

                            <a href="https://www.dld.go.th" target='_blank' className={classes.link}>www.dld.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='department of livestock development' src='/static/img/faq/dld-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        },
        RoyalForest: {
            title: 'กรมป่าไม้',
            logo: renderLogo('/static/img/faq/royal-forest.png', 'royal forest department'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมป่าไม้</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ผลิตภัณฑ์ไม้ทุกชนิด</h1>
                            </div>

                            <p>ต้องขออนุญาตส่งออกไม้กับสำนักเศรษฐกิจการป่าไม้ กรมป่าไม้</p>

                            <p>
                                พระพุทธรูปที่ทำมาจากไม้ หรือมีส่วนประกอบจากไม้ทุกชนิดต้องขออนุญาตส่งออกโบราณ วัตถุ/ศิลปวัตถุ จากกรมศิลปากร กระทรวงวัฒนรรรม หากได้รับอนุญาต จึงทำการขอหนังสือรับรองกับสำนักเศรษฐกิจการป่าไม้ กรมป่าไม้ ก่อนส่งออก
                            </p>

                            <a href="https://www.forest.go.th" target='_blank' className={classes.link}>www.forest.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='royal forest department' src='/static/img/faq/royal-forest-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กรมป่าไม้</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>ผลิตภัณฑ์ไม้ทุกชนิด</h1>
                            </div>

                            <p>ต้องขออนุญาตส่งออกไม้กับสำนักเศรษฐกิจการป่าไม้ กรมป่าไม้</p>

                            <p>
                                พระพุทธรูปที่ทำมาจากไม้ หรือมีส่วนประกอบจากไม้ทุกชนิดต้องขออนุญาตส่งออกโบราณ วัตถุ/ศิลปวัตถุ จากกรมศิลปากร กระทรวงวัฒนรรรม หากได้รับอนุญาต จึงทำการขอหนังสือรับรองกับสำนักเศรษฐกิจการป่าไม้ กรมป่าไม้ ก่อนส่งออก
                            </p>

                            <a href="https://www.forest.go.th" target='_blank' className={classes.link}>www.forest.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='royal forest department' src='/static/img/faq/royal-forest-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        },
        NBTC: {
            title: 'กสทช.',
            logo: renderLogo('/static/img/faq/nbtc.png', 'NBTC'),
            content: trans(
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กสทช.</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>เครื่องมือวิทยุสื่อสาร อุปกรณ์โทรคมนาคม</h1>
                            </div>

                            <p>สำนักงานคณะกรรมการ กิจการกระจายเสียง กิจ การโทรทัศน์ และกิจการ โทรคมนาคมแห่งชาติ</p>

                            <a href="https://www.nbtc.go.th" target='_blank' className={classes.link}>www.nbtc.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='royal forest department' src='/static/img/faq/nbtc-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
                <>
                    <div className={classes.grid}>
                        <div>
                            <div className={classes.titleContainer}>
                                <h1 className={classes.bold}>กสทช.</h1>
                                <h1 className={clsx(classes.bold, classes.highlight)}>เครื่องมือวิทยุสื่อสาร อุปกรณ์โทรคมนาคม</h1>
                            </div>

                            <p>สำนักงานคณะกรรมการ กิจการกระจายเสียง กิจ การโทรทัศน์ และกิจการ โทรคมนาคมแห่งชาติ</p>

                            <a href="https://www.nbtc.go.th" target='_blank' className={classes.link}>www.nbtc.go.th</a>
                        </div>

                        <div className={classes.imageContainer}>
                            <img alt='royal forest department' src='/static/img/faq/nbtc-details.png' style={{ objectFit: 'cover', objectPosition: 'center', width: '300px'}} />
                        </div>
                    </div>
                </>,
            )
        }
    }
}

export default getRestrictedProductsData